import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Switch, Columns, Column } from '@resurs/midas-react'
import { colors } from '@resurs/midas'
import CurrencyInput from '../../../../internal/CurrencyInput'
import { getText } from '../../../../internal/TextLabels'
import SignPendingApplication from './SignPendingApplication'

const newTotalCredit = (limit, card) => {
  return (
    Number(limit) - (Number(card.approvedCredit) - Number(card.usableAmount))
  )
}

const getCoApplicantInfo = coApplicant => {
  if (coApplicant.addresses) {
    return (
      <div>
        {getText(
          'payApply.paymentMethod.coApplicantName',
          coApplicant.addresses[0].fullName,
        )}
        <br />
        {getText(
          'payApply.paymentMethod.coApplicantGovernmentId',
          coApplicant.governmentId,
        )}
      </div>
    )
  }
  return (
    <div>
      {getText(
        'payApply.paymentMethod.coApplicantGovernmentId',
        coApplicant.governmentId,
      )}
    </div>
  )
}

const CreditLimit = ({
  selectedPaymentMethod,
  card,
  data,
  limit,
  minApplicationLimit,
  maxApplicationLimit,
  newCreditLimitChecked,
  isValid,
  onCreditLimitSwitch,
  onChangeLimit,
  disabled,
  showCheckbox,
  coApplicant,
  showOnlyCurrencyNoRange,
}) => {
  return (
    <div>
      {showCheckbox && (
        <Switch
          key={`newCredit_${selectedPaymentMethod.id}`}
          id={`newCredit_${selectedPaymentMethod.id}`}
          text={getText('payApply.paymentMethod.newCreditText')}
          boldText
          checked={newCreditLimitChecked}
          onChange={e => onCreditLimitSwitch(e.target.checked)}
          disabled={disabled}
        />
      )}

      {newCreditLimitChecked && card.coApplicant && (
        <div
          style={{
            border: '1px solid rgba(0,0,0,0.12)',
            borderTop: `3px solid ${colors.orange}`,
            background: 'white',
          }}
        >
          <Column col12 noPadding>
            <div style={{ padding: '2rem' }}>
              <strong>
                {getText('payApply.paymentMethod.coApplicantInfoHeader')}
              </strong>
              <div style={{ padding: '2rem 0' }}>
                {coApplicant && getCoApplicantInfo(coApplicant)}
              </div>
              {getText('payApply.paymentMethod.coApplicantInfo')}
            </div>
          </Column>
        </div>
      )}

      {(!showCheckbox || newCreditLimitChecked) &&
        !(card && !!card.applicationPending) && (
          <Columns>
            <Column col7>
              <CurrencyInput
                id="limit"
                placeholderRange
                showOnlyCurrencyNoRange={showOnlyCurrencyNoRange}
                disabled={disabled}
                label={
                  showCheckbox
                    ? getText('payApply.paymentMethod.creditLabelNew')
                    : getText('payApply.paymentMethod.creditLabel')
                }
                required={getText('payApply.paymentMethod.required')}
                hint={
                  card &&
                  limit > card.approvedCredit && (
                    <span>
                      {getText('payApply.paymentMethod.newTotalCredit')}
                      <strong>
                        <NumberFormat
                          value={newTotalCredit(limit, card)}
                          displayType="text"
                          thousandSeparator=" "
                          renderText={val => getText('default.currency', val)}
                        />
                      </strong>
                    </span>
                  )
                }
                boundaries={{
                  min: {
                    value: minApplicationLimit,
                    error: getText(
                      'payApply.paymentMethod.creditMustBeMoreThanLowerBoundry',
                    ),
                  },
                  max: {
                    value: maxApplicationLimit,
                    error: getText(
                      'payApply.paymentMethod.cretidMustBeLessThanUpperBoundry',
                    ),
                  },
                }}
                isValid={validation => isValid(validation)}
                onValueChange={value => onChangeLimit(value.floatValue)}
                value={limit}
              />
            </Column>
          </Columns>
        )}

      {(!showCheckbox || newCreditLimitChecked) &&
        card &&
        !!card.applicationPending && (
          <Columns>
            <Column col12>
              <SignPendingApplication card={card} data={data} />
            </Column>
          </Columns>
        )}
    </div>
  )
}

CreditLimit.propTypes = {
  selectedPaymentMethod: PropTypes.object.isRequired,
  limit: PropTypes.number,
  minApplicationLimit: PropTypes.number,
  maxApplicationLimit: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  showCheckbox: PropTypes.bool,
  card: PropTypes.object,
  data: PropTypes.object,
  newCreditLimitChecked: PropTypes.bool,
  onCreditLimitSwitch: PropTypes.func,
  coApplicant: PropTypes.object,
  showOnlyCurrencyNoRange: PropTypes.bool,
}

CreditLimit.defaultProps = {
  card: null,
  limit: null,
  data: null,
  newCreditLimitChecked: false,
  onCreditLimitSwitch: null,
  minApplicationLimit: null,
  showCheckbox: false,
  coApplicant: null,
  showOnlyCurrencyNoRange: false,
}

export default CreditLimit
